module.exports = __webpack_public_path__ + "img/1.a61ceef7.jpg";